export const calculateHourlyRate = (salaryValue, salaryType) => {
  if (salaryType === 'hourly') return parseFloat(salaryValue);
  return parseFloat(salaryValue) / 2080;
};

export const calculateCostPerMinute = (participants) => {
  const totalHourlyRate = participants.reduce((sum, p) => {
    return sum + calculateHourlyRate(p.salaryValue, p.salaryType);
  }, 0);
  return totalHourlyRate / 60;
};